import { media, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const NoProductsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${media.lessThan('tablet')`
    margin: 0 ${spacing.medium} 0 0;
  `}
`;

export const ContainerCentering = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: ${spacing.large} ${spacing.medium};

  > span {
    margin: 0 0 ${spacing.medium} 0 !important;
  }
`;

export const TextContainer = styled.div`
  margin: ${spacing.small} 0 ${spacing.medium} 0;
`;
